<template>
  <div class="between m-t-60">
    <tx-bg src="oldclassic_p_roleinfo_img_yhz_db_1">
      <tx-bg src="oldclassic_p_roleinfo_img_yhzbiaoti_db" class="btn_yeqian3">
        <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian">
          基本信息
        </tx-bg>
      </tx-bg>

      <div class="column">
        <div class="px-40 pt-24">
          <t-row
            v-for="(item, i_margin1) in margin1"
            :key="i_margin1"
            :title="item.text"
            titleClass="t-title-jichu"
            valueClass="roleinfo-attr-value row-value-bg"
            :value="phantom[item.key]"
            class="m-tb-4"
          />
        </div>
      </div>
    </tx-bg>

    <tx-bg src="oldclassic_p_roleinfo_img_yhz_db_1">
      <tx-bg src="oldclassic_p_roleinfo_img_yhzbiaoti_db" class="btn_yeqian3">
        <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian">
          基本属性
        </tx-bg>
      </tx-bg>

      <div class="column px-40 pt-24">
        <div class="grid-2">
          <t-row
            v-for="(item, a_index) in attr"
            :key="a_index"
            :title="item.text"
            valueClass="roleinfo-attr-value row-value-bg"
            :value="phantom[`b_${item.key}`] || 0"
            class="m-tb-4"
          />
        </div>

        <t-row
          title="可分配点数"
          valueClass="roleinfo-attr-value row-value-bg"
          :value="phantom['attrib_point'] || 0"
          class="m-tb-4"
        />
      </div>

      <div class="middle m-t-16">
        <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian">
          神启属性
        </tx-bg>
      </div>

      <div class="column px-40">
        <div class="grid-2">
          <t-row
            v-for="(item, a_index) in attr"
            :key="a_index"
            :title="item.text"
            valueClass="roleinfo-attr-value row-value-bg"
            :value="phantom[`fs_${item.key}`] || 0"
            class="m-tb-4"
          />
        </div>
      </div>
    </tx-bg>

    <tx-bg src="oldclassic_p_roleinfo_img_yhz_db_1">
      <tx-bg src="oldclassic_p_roleinfo_img_yhzbiaoti_db" class="btn_yeqian3">
        <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian">
          技 能
        </tx-bg>
      </tx-bg>

      <div class="grid-3 px-8 pt-24">
        <commonItem
          class="jn-container"
          :name="phantom_skill['name']"
          :content="phantom_skill['intro']"
          v-for="(phantom_skill, i) in phantom['skills']"
          :key="i"
          :src="yhz_img(phantom_skill['id'], 2)"
        >
          <template v-slot:title>
            <span class="tooltip_title tooltip_title_color">{{
              phantom_skill['name']
            }}</span>
          </template>
        </commonItem>

        <commonItem
          class="jn-container"
          :name="phantom_skill['name']"
          :content="phantom_skill['intro']"
          v-for="(phantom_skill, i) in phantom['pskills']"
          :key="i"
          :src="yhz_img(phantom_skill['id'], 1)"
        >
          <template v-slot:title>
            <span class="tooltip_title tooltip_title_color">
              {{ phantom_skill['name'] }}
            </span>
          </template>
        </commonItem>

        <commonItem
          class="jn-container"
          v-if="phantom.seventh_skill"
          :name="phantom['seventh_skill_name']"
          :content="phantom['seventh_skill_intro']"
          :src="
            yhz_img(phantom['seventh_skill'], phantom['seventh_skill_type'])
          "
        >
          <template v-slot:title>
            <span class="tooltip_title tooltip_title_color">{{
              phantom['seventh_skill_name']
            }}</span>
          </template>
        </commonItem>

        <commonItem
          class="jn-container"
          v-if="phantom.seventh_extra_skill"
          :name="phantom['seventh_extra_skill_name']"
          :content="phantom['seventh_extra_skill_intro']"
          :src="
            yhz_img(
              phantom['seventh_extra_skill'],
              phantom['seventh_extra_skill_type']
            )
          "
        >
          <template v-slot:title>
            <span class="tooltip_title tooltip_title_color">{{
              phantom['seventh_extra_skill_name']
            }}</span>
          </template>
        </commonItem>
      </div>

      <template
        v-if="
          phantom['tongtian_skills'] && phantom['tongtian_skills'].length > 0
        "
      >
        <div class="middle m-t-16">
          <tx-bg src="oldclassic_p_roleinfo_img_biaoti" class="btn_yeqian">
            化 神
          </tx-bg>
        </div>

        <div class="grid-3">
          <commonItem
            class="jn-container"
            :name="phantom_skill['name']"
            :content="phantom_skill['intro']"
            v-for="(phantom_skill, i) in phantom['tongtian_skills']"
            :key="i"
            :src="yhz_img(phantom_skill['id'], 1)"
          >
            <template v-slot:title>
              <span class="tooltip_title tooltip_title_color">{{
                phantom_skill['name']
              }}</span>
            </template>
          </commonItem>

          <commonItem
            class="jn-container"
            :name="phantom_skill['name']"
            :content="phantom_skill['intro']"
            v-for="(phantom_skill, i) in phantom['tongtian_pskills']"
            :key="i"
            :src="yhz_img(phantom_skill['id'], 1)"
          >
            <template v-slot:title>
              <span class="tooltip_title tooltip_title_color">{{
                phantom_skill['name']
              }}</span>
            </template>
          </commonItem>
        </div>
      </template>
    </tx-bg>
  </div>
</template>

<script setup>
const { attr } = inject('Game');

const { yhz_img } = inject('filters');

const props = defineProps({
  phantom: {
    type: Object,
    default: () => ({}),
  },
});

const margin1 = ref([
  { text: '元魂珠名', key: 'init_name' },
  { text: '星级', key: 'mstar' },
  { text: '系别', key: 'type_name' },
  { text: '等级', key: 'lv' },
  { text: '经验', key: 'exp' },
  { text: '能量等级', key: 'en_lv' },
  { text: '魂魄', key: 'power' },
  { text: '成长优势', key: 'evolution' },
  { text: '移动速度', key: 'speed_move' },
  { text: '吸收能力', key: 'en_absorb' },
  { text: '修为', key: 'xiuwei' },
  { text: '元魂代数', key: 'generation' },
  { text: '可洗技能数', key: 'erasable' },
  { text: '神启等级', key: 'flysoul_lv' },
  { text: '参悟', key: 'penetrate' },
  { text: '元魂四象', key: 'fs_fp_lv' },
]);
</script>
